<div
  class="alert d-flex"
  id="size"
  [style.background-color]="backgroundColor"
  [style.display]="closebtn"
  role="alert"
>
  <i class="fa fa-exclamation-triangle img-thumbnail"></i>
  <p id="text">{{ displaydata }}</p>
  <button
    type="button"
    class="alert-close"
    (click)="close()"
    aria-label="Close alert"
  >
    ×
  </button>
</div>
